<app-content-wrapper
  [title]="'nav.menu'">
  <div class="box-wrapper">
    @for (productFamily of productFamilies$ | async; track trackById($index, productFamily)) {
      <div class="box" (click)="selectCategory(productFamily.id)"
                [ngClass]="{
                    'not-selected': !!selectedFamily && (selectedFamily.id !== productFamily.id)
                }">
        <img
          [src]="'assets/images/thumb/categories/' + productFamily.id + '.jpg'"
          width="100%"
          />
          <div class="category"> <p style="color: var(--color-orange-brown-100)" lang="pt"> {{ productFamily.id | translate }} </p></div>
        </div>
      }
    </div>
    @if (!selectedFamily) {
      <span class="center"> {{ "pick-category" | translate }} </span>
    }
    @if (selectedFamily?.categories; as categories) {
      <div id="menu-elements">
        <div style="margin: 0 20px">
          <app-menu-item
            [categories]="categories">
          </app-menu-item>
        </div>
      </div>
    }
  </app-content-wrapper>